import { render, staticRenderFns } from "./ashebei.vue?vue&type=template&id=03e5d908&scoped=true&"
import script from "./ashebei.vue?vue&type=script&lang=js&"
export * from "./ashebei.vue?vue&type=script&lang=js&"
import style0 from "./ashebei.vue?vue&type=style&index=0&id=03e5d908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5d908",
  null
  
)

export default component.exports